import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { login2FA, userForgetPasswordReset, verify2FA } from '../../api/User';
import { Form, Input, message, Button, notification } from 'antd';
import { CustomInput } from '../../components/CustomForm';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setToken, setTwoFA, setUser } from '../../features/user/userSlice';

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageContent = styled.div`
  width: 100%;
  max-width: 600px;
`;

const PageTitle = styled.div`
  font-size: 32px;
  color: #fff;
  margin-bottom: 15px;
`;

const TwoFA = () => {
  const [loading, setLoading] = useState(false);
  const [KEY, setKEY] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [params] = useSearchParams()

  // 初始化数据
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      navigate('/');
    }
  }, [location.state]);

  // 验证2FA-Code
  const Verfiy = async (value) => {
    setLoading(true);
    try {
      const res = await login2FA({
          user_id: params.get('id'),
          secret:value.secret
      });
      
      if (res.code === '10000') {
        message.success(t('loginPage.message.success'));
        setLoading(false);
        if (!res.data.user.wallet_address && res.data.user.type !== 1) {
          notification.warning({
            key:'warning',
            message: '',
            description: (
              <span
                style={{
                  fontSize: '16px',
                }}
              >
                Please set your wallet address before submitting your report.
              </span>
            ),
            duration: 5000,
            btn: (
              <Button
                size="small"
                style={{
                  height: '32px',
                  backgroundColor: '#18EAC4',
                  borderColor: '#18EAC4',
                  color: '#000',
                  borderRadius: '6px',
                }}
                onClick={() => {
                  notification.close('warning');
                  navigate('/user?page=my_info', { state: { wallet_address: true } });
                }}
              >
                Setting
              </Button>
            ),
          });
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }else if(params.get('redirect_url')){
          if(params.get('redirect_url') !== '/login'){
            navigate(params.get('redirect_url'));
          }
          navigate('/');
        }else{
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }
        
        dispatch(setUser(res.data));
        dispatch(setToken(`${res.data.type} ${res.data.token}`));
        dispatch(setTwoFA(res.data.user.two_fa));
      } else {
        setLoading(false);
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  const handleFormFinsh = async (value) => {
    Verfiy(value);
  };

  return (
    <PageContainer>
      <PageContent>
        <PageTitle>Two-factor authentication</PageTitle>
        <Form
          layout={'vertical'}
          autoComplete="off"
          requiredMark={false}
          onFinish={handleFormFinsh}
        >
          <Form.Item
            name={'secret'}
            rules={[{ required: true, message: 'Please input your 2-FA Code!' }]}
          >
            <CustomInput placeholder='XXXXXX' />
          </Form.Item>
          <Form.Item>
            <Button
              type={'text'}
              htmlType={'submit'}
              loading={loading}
              style={{
                height: '42px',
                backgroundColor: '#18EAC4',
                color: '#000000',
                borderColor: '#18EAC4',
                borderRadius: '4px',
              }}
            >
              Verify
            </Button>
          </Form.Item>
        </Form>
      </PageContent>
    </PageContainer>
  );
};

export default TwoFA;
